import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export interface UrlRowProperties {
  label: string;
  linkUrl: string;
  linkName?: string;
}

export const UrlRow = ({
  label,
  linkUrl,
  linkName,
}: UrlRowProperties): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="final-screen__item">
      <div className="final-screen__text">{t(label)}: </div>
      <div className="final-screen__text final-screen__text--scrolled">
        <a
          href={linkUrl}
          target="_blank"
          className="final-screen__link"
          rel="noreferrer"
        >
          {linkName || t('clickHere.linkName')}
        </a>
      </div>
    </div>
  );
};
